// DTOs for the read-only audit log surface. The shape is identical to the
// `audit_log` table except `meta` is typed as an unknown record (producers
// shape the field per action; callers should not rely on specific keys).
//
// Actions follow the convention `namespace.event_name` — e.g.
// `billing.subscription.upserted`, `identity.user_provisioned`,
// `reconciliation.drift_alert`. The dashboard filter matches on the
// namespace prefix so a single dropdown groups related events without
// the UI needing to know the full action vocabulary.
import { Type } from '@sinclair/typebox';
export const AuditLogEntrySchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    // Internal user who performed the action, or null when the event was
    // produced by a system component (webhook handler, scheduled job).
    actorId: Type.Union([Type.String({ format: 'uuid' }), Type.Null()]),
    action: Type.String({ minLength: 1, maxLength: 128 }),
    // Freeform target — usually the id of the resource being changed. Null
    // for events that are not bound to a single resource (e.g. a failed
    // reconciliation run that covers many rows).
    target: Type.Union([Type.String({ minLength: 1, maxLength: 128 }), Type.Null()]),
    meta: Type.Record(Type.String(), Type.Unknown()),
    // IP + UA are best-effort — absent for events emitted off the request
    // path (webhooks, scheduled jobs).
    ip: Type.Union([Type.String(), Type.Null()]),
    userAgent: Type.Union([Type.String(), Type.Null()]),
    ts: Type.String({ format: 'date-time' }),
}, { $id: 'AuditLogEntry', additionalProperties: false });
export const AuditLogListResponseSchema = Type.Object({
    entries: Type.Array(AuditLogEntrySchema),
}, { $id: 'AuditLogListResponse', additionalProperties: false });
//# sourceMappingURL=audit-log.js.map